module.exports = __webpack_public_path__ + "static/media/global-goals.1fdbb587.svg";